var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no404"},[_c('img',{staticClass:"errimg",attrs:{"src":require("../assets/img/500.svg")}}),_c('h4',[_vm._v("抱歉，服务器好像出错了哦")])])
}]

export { render, staticRenderFns }